import React from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { injectIntl, FormattedMessage } from 'react-intl'
import Avatar from '@material-ui/core/Avatar'
import IconButton from '@material-ui/core/IconButton'
import Popover from '@material-ui/core/Popover'
import MenuItem from '@material-ui/core/MenuItem'
import MenuList from '@material-ui/core/MenuList'
import SvgIcon from '@material-ui/core/SvgIcon'
import Badge from '@material-ui/core/Badge'
import { getProfileMenu } from 'helpers/menuProfile'
import RoleHelper, { ROLE_FEATURE_MANAGER } from 'helpers/role'
import * as ROUTE from 'constants/appRouting'
import defaultAvatar from 'assets/img/default-avatar.png'
import FilterLicensee from 'components/Dashboard/FilterLicensee'
import 'styles/app/layout/nav-right.scss'
import { showFeedbackFormModal } from 'reducers/feedback/reducer'
import { ReactComponent as MenuIconLogout } from 'assets/img/menu/menuIconLogout.svg'
import { ReactComponent as AdminIcon } from 'assets/img/SAdminIcon.svg'
import messages from '../translate'

class NavRightList extends React.Component {
  state = {
    anchorEl: null,
  }

  menuClickHandlers = {
    leaveFeedback: () => this.props.showFeedbackFormModal(true),
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  render() {
    const {
      roleLevel,
      userData,
      intl: { formatMessage },
      allowedToManageWorkflows,
    } = this.props
    const { name, pictureUrl, licensee, roles } = userData.toJS()
    const isSuperAdmin = roleLevel >= RoleHelper.ROLE_SUPERADMIN_LEVEL
    const menuItems = getProfileMenu(
      roleLevel,
      allowedToManageWorkflows,
      roles.includes(ROLE_FEATURE_MANAGER),
    )
    const { anchorEl } = this.state
    let itemGroupNumber = 1

    return (
      <ul className="list-unstyled float-right">
        <li className="profile-item">
          <IconButton
            href={null}
            className="header-btn"
            aria-owns={anchorEl ? 'app-header-menu' : null}
            aria-haspopup="true"
            onClick={this.handleClick}>
            <Badge
              badgeContent={
                isSuperAdmin ? (
                  <SvgIcon className="icon-admin" component={AdminIcon} />
                ) : (
                  0
                )
              }>
              <Avatar
                component="div"
                src={pictureUrl || defaultAvatar}
                alt="name"
                className="rounded-circle header-avatar"
              />
            </Badge>
          </IconButton>

          <Popover
            id="app-header-menu"
            className="app-header-dropdown"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
            PaperProps={{
              className: 'right-menu-paper',
            }}>
            <MenuList className="nav-left-menu">
              {isSuperAdmin && (
                <MenuItem button component="li" key="licensee_list">
                  <FilterLicensee />
                </MenuItem>
              )}
              {menuItems.map(({ path, alt, name, icon, group }) => {
                if (typeof group === 'number') {
                  let divider = null

                  if (itemGroupNumber !== group) {
                    itemGroupNumber = group
                    divider = <div className="divider divider-solid my-1" />
                  }

                  return (
                    <li key={name} className="menu-item-wrapper">
                      {divider}
                      <MenuItem
                        component="div"
                        className="nav-menu-item"
                        button
                        onClick={this.handleClose}
                        key={alt}>
                        <Link
                          to={path}
                          onClick={
                            this.menuClickHandlers.hasOwnProperty(name)
                              ? this.menuClickHandlers[name]
                              : undefined
                          }>
                          <i className="nav-menu-icons">{icon}</i>
                          <span>
                            <FormattedMessage {...messages[name]} />
                          </span>
                        </Link>
                      </MenuItem>
                    </li>
                  )
                }

                return null
              })}
            </MenuList>

            <MenuList className="nav-right-menu">
              <MenuItem
                component="li"
                button
                onClick={this.handleClose}
                key="UserInfo">
                <div className="menu-avatar-wrapper">
                  <Avatar
                    component="div"
                    src={pictureUrl || defaultAvatar}
                    alt="name"
                    className="rounded-circle header-avatar"
                  />
                  <div>
                    <strong>{name || formatMessage(messages.anonymous)}</strong>
                    <span className="licenseename">
                      &nbsp;(
                      {licensee && !isSuperAdmin ? (
                        licensee.name
                      ) : (
                        <FormattedMessage {...messages.company_name} />
                      )}
                      )
                    </span>
                  </div>
                </div>
              </MenuItem>

              {menuItems.map(({ path, alt, name, icon, group }) => {
                if (group === 'right side') {
                  return (
                    <MenuItem
                      component="li"
                      className="nav-menu-item"
                      button
                      onClick={this.handleClose}
                      key={alt}>
                      <Link to={path}>
                        <i className="nav-menu-icons">{icon}</i>
                        <span>
                          <FormattedMessage {...messages[name]} />
                        </span>
                      </Link>
                    </MenuItem>
                  )
                }

                return null
              })}

              <MenuItem
                component="li"
                className="nav-menu-logout"
                button
                onClick={this.handleClose}
                key="Logout">
                <Link to={ROUTE.LOGOUT}>
                  <i className="nav-menu-icons">
                    <MenuIconLogout />
                  </i>
                  <span>
                    <FormattedMessage {...messages.logout} />
                  </span>
                </Link>
              </MenuItem>
            </MenuList>
          </Popover>
        </li>
      </ul>
    )
  }
}

export default injectIntl(
  withRouter(
    connect(
      state => ({
        roleLevel: state.getIn(['profile', 'roleLevel']),
        userData: state.getIn(['profile', 'profile']),
        allowedToManageWorkflows: state.getIn([
          'profile',
          'profile',
          'grantedManageWorkflows',
        ]),
      }),
      {
        showFeedbackFormModal,
      },
    )(NavRightList),
  ),
)
